import styled from 'styled-components';
import { Form } from '@unform/web';
import CorUtil from '../../../functions/corUtil';

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  margin: 1rem;
`;

export const Formulario = styled(Form)`
  display: flex;
  flex-direction: column;

  width: 95%;
  margin: 1rem;
  gap: 10px;

  hr {
    margin: 1rem 0px;
    height: 1px;

    background-color: ${(props) => CorUtil.rgba(props.theme['DARK_DARKER'], 0.1)};
    border: none;
  }
`;

export const ConteinerBotoes = styled.div`
  display: flex;
  align-self: end;

  width: fit-content;
`;

export const LinhaFormulario = styled.div`
  display: flex;
  gap: 1rem;
`;
